import {Button, Steps} from 'antd'
import classNames from 'classnames'
import {Formik} from 'formik'
import useTranslate from 'modules/local/useTranslate'
import React, {useContext, useState} from 'react'
import {NullAsDefault, renderIf} from 'views/Shared'
import {LayoutContext} from '../layouts/Default/LayoutContext'
import {renderIfElse} from "../../views/Shared";

const {Step} = Steps

export const StepsForm = ({
                              className,
                              children,
                              routes = [],
                              initialValues = {},
                              renderBottom,
                              onSubmit,
                              onCancel,
                              isLoading,
                              faded = true,
                              actionBarCenter = false,
                              stepHeader = false,
                              validate = NullAsDefault,
                              ...propsRest
                          }) => {
    const t = useTranslate()
    const {isSm} = useContext(LayoutContext)
    const [currentIndex, setCurrentIndex] = useState(0)
    const handleOnBack = () => setCurrentIndex(Math.max(0, currentIndex - 1))
    const C = routes[currentIndex].component

    // lấy validate của step hiện tại
    const stepValidate = routes[currentIndex]?.validate || (() => ({}))
    return (
        <Formik
            enableReinitialize
            initialValues={initialValues}
            onSubmit={onSubmit}
            validate={stepValidate}
            {...propsRest}>
            {({handleChange, handleSubmit, values, setTouched, setErrors, validateForm, ...rest}) => {
                const handleOnOk = async () => {
                    const stepFields = routes[currentIndex]?.fields || []
                    const allErrors = await validateForm(values)
                    const stepErrorKeys = Object.keys(allErrors).filter(k => stepFields.includes(k))
                    const hasStepErrors = stepErrorKeys.length > 0

                    if (hasStepErrors) {
                        const touchedPatch = stepFields.reduce((acc, f) => {
                            acc[f] = true
                            return acc
                        }, {})
                        setTouched(prev => ({...(prev || {}), ...touchedPatch}))
                        return
                    }

                    if (currentIndex === routes.length - 1) {
                        handleSubmit()
                    } else {
                        setCurrentIndex(i => Math.min(routes.length - 1, i + 1))
                    }
                }
                return (
                    <div className="flex flex-col gap-4">
                        {children && children(currentIndex)}
                        <div className="w-full flex flex-col space-y-1 max-w-3xl">
                            {renderIf(
                                stepHeader,
                                <div className={className}>
                                    <Steps
                                        type="inline"
                                        size="small"
                                        className="mt-6 px-3 md:px-8"
                                        direction="horizontal"
                                        labelPlacement="horizontal"
                                        style={{flexDirection: isSm && 'row'}}
                                        current={currentIndex}>
                                        {routes.map((e, i) => (
                                            <Step
                                                key={i}
                                                status={
                                                    i === currentIndex
                                                        ? 'process'
                                                        : i < currentIndex
                                                        ? 'finish'
                                                        : 'wait'
                                                }
                                            />
                                        ))}
                                    </Steps>
                                </div>
                            )}
                            {
                                renderIf(
                                    !!routes[currentIndex]?.title,
                                    <div className="text-center font-bold text-2xl px-3 pt-3 uppercase leading-snug">
                                        {t(routes[currentIndex].title)}
                                    </div>
                                )
                            }
                            {
                                renderIf(
                                    !!routes[currentIndex]?.description,
                                    <div
                                        className="uppercase text-sm font-semibold text-color-300 tracking-wide mb-1 text-center">
                                        {t(routes[currentIndex].description)}
                                    </div>
                                )
                            }
                        </div>
                        <div
                            key={currentIndex}
                            className={classNames(faded && 'animated fadeIn faster')}>
                            <C
                                {...{
                                    currentIndex,
                                    values: values,
                                    onChange: handleChange,
                                    onNext: handleOnOk,
                                    onBack: handleOnBack,
                                    onCancel: onCancel,
                                    ...propsRest,
                                    ...rest,
                                }}
                            />
                        </div>
                        {/*{renderIf(!isSm, <div className="flex-1" />)}*/}
                        {renderBottom ? (
                            renderBottom({
                                currentIndex,
                                values: values,
                                onChange: handleChange,
                                onNext: handleOnOk,
                                onBack: handleOnBack,
                                ...rest,
                            })
                        ) : (
                            <div className={
                                classNames(
                                    "z-10 bottom-0 mt-3 md:mt-8 p-3 sticky background flex items-center gap-3",
                                    actionBarCenter === true ? 'justify-center' : 'justify-end'
                                )
                            }>
                                {renderIfElse(
                                    routes.length > 1,
                                    <Button
                                        type="text"
                                        className="button-rounded-lg no-border text-sm text-color-300"
                                        disabled={currentIndex === 0}
                                        onClick={handleOnBack}>
                                        {t('back')}
                                    </Button>,
                                    renderIf(
                                        onCancel,
                                        <div
                                            onClick={onCancel}
                                            className="text-sm text-color-300 hover:text-color-100 cursor-pointer">
                                            {t('close')}
                                        </div>
                                    )
                                )}
                                <Button
                                    type="primary"
                                    loading={isLoading}
                                    onClick={handleOnOk}
                                    className="button-rounded-lg no-border"
                                    disabled={!rest.isValid || !rest.dirty}>
                                    {currentIndex === routes.length - 1 ? t('submit') : t('next')}
                                </Button>
                            </div>
                        )}
                    </div>
                )
            }}
        </Formik>
    )
}
